import { render, staticRenderFns } from "./SelectWithRegister.vue?vue&type=template&id=5851e237&"
import script from "./SelectWithRegister.vue?vue&type=script&lang=js&"
export * from "./SelectWithRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports